import styled from 'styled-components';
import { theme } from '../../../theme';
const borderModeStyles = {
    full: `border-width: 1px; border-radius: ${theme.radius.base};`,
    vertical: 'border-width: 0; border-top-width: 1px; border-bottom-width: 1px;',
    none: 'border-width: 0;',
};
export const Wrapper = styled.div.withConfig({ displayName: "vui--Wrapper", componentId: "vui--1xqen7k" }) `width:100%;position:relative;border-style:solid;border-color:${theme.colors.neutral.grey.dark};${({ borderMode = 'full' }) => borderModeStyles[borderMode]} &,& *{box-sizing:border-box;}`;
//# sourceMappingURL=Wrapper.js.map